/**
 * 表格 / 表单列宽常量（px）。
 * 使用 `as const`，发布后的 `.d.ts` 仍保留具体数值，IDE 悬停可直接看到。
 *
 * @example
 * import { ColWidth } from 'fantasy-ngzorro';
 * { width: ColWidth.enumColWidth } // 100
 */
export const ColWidth = {
  /** 表格小图标宽度 — 25 */
  tableImageColWidth: 25,
  /** 表格双小图标宽度 — 40 */
  tableTwoImageColWidth: 40,
  /** 单据单号列宽度 — 150 */
  billNumberColWidth: 150,
  /** 基本资料名称列宽度 — 150 */
  nameColWidth: 150,
  /** 基本资料代码列宽度 — 100 */
  codeColWidth: 100,
  /** 门店/货主/供应商 `[code]name` 展示固定宽度 — 200 */
  codeNameColWidth: 200,
  /** 枚举列宽度 — 100 */
  enumColWidth: 100,
  /** 单个日期 — 100 */
  dateColWidth: 100,
  /** 单个日期带时间 — 150 */
  dateTimeColWidth: 150,
  /** 日期范围 — 200 */
  dateRangeWidth: 200,
  /** 操作列宽度 — 150 */
  operateColWidth: 150,
  /** 数字列 — 100 */
  numberColWidth: 100,
  /** 备注列 — 250 */
  remarkColWidth: 250,
  /** 通用固定宽（超长省略）— 150 */
  fixColWidth: 150,
  /** 订单等内容缩略/展开列 — 350 */
  maxColWidth: 350,
} as const;
